<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    class="h-[60%] min-h-[10%] overflow-auto"
  >
    <div>
      <MateTraitSelectionById
        v-if="!reloadMateTrait"
        :mate-id="mateId"
        :selected-trait-id="selectedTraitId"
        @update:selectedTrait="onSelectMateTrait"
        enable-selection
      />
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  selectedTraitId: {
    type: Number,
    default: 0,
  },
  mateId: {
    type: Number,
    default: 0,
  },
});
const reloadMateTrait = ref(false);

watch(
  () => props.mateId,
  (newVal) => {
    reloadMateTrait.value = true;
    setTimeout(() => {
      reloadMateTrait.value = false;
    });
  }
);
const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
  (e: "update:selectedTrait", trait: MateTrait | null): void;
}>();

const onSelectMateTrait = (trait: MateTrait | null) => {
  emit("update:selectedTrait", trait);
};
</script>
